import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ModalService } from '@core/services/modal/modal.service';
import { BackgroundImageModalAction } from '@root/app.interfaces';

@Component({
	selector: 'app-change-background-image-modal',
	templateUrl: './change-background-image-modal.component.html',
	styleUrls: [
		'../confirm-modal/confirm-modal.component.scss',
		'../confirm-modal/confirm-modal.responsive.scss',
		'./change-background-image-modal.component.scss',
	],
})
export class ChangeBackgroundImageModalComponent implements OnInit {
	static readonly ID = crypto.randomUUID();
	readonly Actions = BackgroundImageModalAction;

	constructor(
		private matDialogRef: MatDialogRef<ChangeBackgroundImageModalComponent>,
		private modalService: ModalService,
	) {}

	ngOnInit(): void {
		this.modalService.liftUpModal(this.matDialogRef);
	}

	close(type: BackgroundImageModalAction) {
		this.matDialogRef.close(type);
	}
}
